import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import Host from "../../Components/Host";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useGetUserDataQuery } from "../../services/login";
import _, { isArray, pad } from "lodash";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "react-bootstrap";
import Rating from "@mui/material/Rating";
import Variation from "./Variation";
import Button from "@mui/joy/Button";
import formatPrice from "../formatPrice";
import ProductCountries from "../Header/ProductCountries";
import { useMediaQuery } from "react-responsive";
import Divider from "@mui/material/Divider";
import StoreMallDirectoryOutlinedIcon from "@mui/icons-material/StoreMallDirectoryOutlined";
import FlashOnIcon from "@mui/icons-material/FlashOn";
var moment = require("moment");

function ProductFeatures({ productData, productFetching, title, id, isLoading, isFetching, productNotAvailable }) {
  const { userId, userToken, cartToken, languageCode, countryCode } = useSelector((state) => state.auth);
  const history = useHistory();
  const { t } = useTranslation();
  const isMobcreen = useMediaQuery({ query: "(min-width: 0px) and (max-width: 992px)" });

  let fontFamilyForAll;
  if (languageCode === "ar") {
    fontFamilyForAll = "GessTwoMedium, sans-serif";
  } else if (languageCode === "urdu") {
    fontFamilyForAll = "AlQalam Shakir";
  } else {
    fontFamilyForAll = "Poppins, sans-serif";
  }
  const fontFamily = {
    fontFamily: fontFamilyForAll,
  };

  const [getFeaturesLength, setFeaturesLength] = useState(false);
  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const deliveryDaya = Number(productData?.estimated_delivery) + Number(userData?.contant?.delivery_days || 0);
  function getTimeline() {
    if (Number(deliveryDaya) === 1) {
      return "Tomorrow";
    } else {
      return "";
    }
  }

  function getDeliverydays() {
    if (Number(deliveryDaya) > 0) {
      return (
        <span style={{ fontWeight: 500 }}>
          {getTimeline()} {moment().add(Number(deliveryDaya), "days").format("ddd Do MMM")}
        </span>
      );
    } else {
      return <span style={{ fontWeight: 500 }}>{moment().add(7, "days").format("dddd Do MMM YYYY")}</span>;
    }
  }

  const [geturnModal, returnModal] = useState(false);
  function returnPolicyModal() {
    returnModal(true);
  }

  function closeModal() {
    returnModal(false);
  }

  const thisFeatures = productData?.features;

  const thisProTitle =
    productData?.title?.replace(/[^\w\s.,'/:]/gi, " ") || title?.replace(/-/g, " ")?.replace(/[^\w\s.,'/:]/gi, " ");
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };
  const truncatedTitle =
    thisProTitle?.split(" ").length > 100 ? thisProTitle?.split(" ").slice(0, 100).join(" ") + "..." : thisProTitle;

  function localViewStore() {
    return (
      <Link
        className="text-hover-link"
        to={`/store/${productData?.store_id}`}
        style={{ display: "flex", alignItems: "center", gap: "3px" }}
      >
        <span style={{ display: "flex", alignItems: "center" }}>
          <StoreMallDirectoryOutlinedIcon style={{ fontSize: "1.2rem" }} />
        </span>
        <span className="pp--header-hvr-link">{t("view_store")}</span>
      </Link>
    );
  }

  function getStockQnty(quantity) {
    if (productData?.store_id != 3) {
      return "";
      // <span style={{ color: 'tomato' }}>Only {quantity} stock left</span>
    } else if (Number(quantity) === 0) {
      return (
        <div className="pp--header-card">
          <span className="pp--header-title">{t("availability")}:</span>
          <span className="pp--header-text" style={{ color: "tomato" }}>
            {t("out_of_stock")}
          </span>
        </div>
      );
    } else {
      return "";
      // <span style={{ color: '#02732f' }}>
      //   In Stock <CheckOutlinedIcon style={{ fontSize: '15px', color: '#02732f' }} />
      // </span>
    }
  }

  const tabbyCurrencies = ["SAR", "AED", "BHD", "QAR", "KWD"];

  function thisPricesList() {
    return (
      <div className="pg-price" style={{ color: "#000000c4", fontSize: "1.4rem", margin: "0px 3px", lineHeight: 1.1 }}>
        {productFetching ? (
          <Skeleton variant="rect" style={{ height: "22px", width: "22%" }} />
        ) : (
          <>
            {!productNotAvailable && (
              <h5 style={{ fontSize: "1.4rem", display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                <span>
                  {formatPrice(
                    productData?.prices?.value,
                    productData?.prices?.currency ? productData?.prices?.currency : userData?.contant?.currency,
                    0
                  )}
                </span>
                &nbsp;
                {productData?.prices?.deal_value && (
                  <span
                    style={{
                      color: "#721c24",
                      fontSize: "14px",
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{ color: "#828282", fontSize: "14px", textDecoration: "line-through", fontWeight: 400 }}
                    >
                      {formatPrice(
                        productData?.prices?.price,
                        productData?.prices?.currency ? productData?.prices?.currency : userData?.contant?.currency,
                        0
                      )}
                    </span>
                    &nbsp;
                    {/* {productData?.prices?.discount &&
                    <span className='badge badge-danger' style={{ fontSize: '12px', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                      {`-${productData?.prices?.discount}%`}
                    </span>
                  } */}
                    {productData?.prices?.deal_value && (
                      <span className="badge badge-danger" style={{ width: "auto" }}>
                        <FlashOnIcon style={{ fontSize: "1rem" }} />
                      </span>
                    )}
                  </span>
                )}
              </h5>
            )}
          </>
        )}
      </div>
    );
  }

  return (
    <div className="purchase-info-sub-card">
      <Modal style={fontFamily} className="refund-modal" show={geturnModal} onHide={closeModal} animation={true}>
        <Modal.Body>
          <IconButton
            style={{ cursor: "pointer", position: "absolute", right: "10px", top: "10px", zIndex: 111 }}
            onClick={closeModal}
          >
            <CloseIcon className="Header-close-modal-icon" />
          </IconButton>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <p id="#return" style={{ marginBottom: "11px" }}>
                  <span style={{ fontSize: "11pt" }}>
                    <span style={{ lineHeight: "107%" }}>
                      <strong>{Host?.domainName} Protect</strong>
                    </span>
                  </span>
                </p>
                <ol style={{ padding: "10px" }}>
                  <li style={{ marginLeft: "8px" }}>
                    <span style={{ fontSize: "11pt" }}>
                      <span style={{ lineHeight: "107%" }}>
                        <span>
                          Shop with confidence. {Host?.domainName} Protect covers eligible issues from delivery to
                          after-sales support, including damaged, defective, incorrect, missing, or not-as-described
                          items, plus warranty support where applicable.{" "}
                        </span>
                      </span>
                    </span>
                  </li>
                  <li style={{ marginLeft: "8px" }}>
                    <span style={{ fontSize: "11pt" }}>
                      <span style={{ lineHeight: "107%" }}>
                        <span>
                          Report eligible issues within 3 days of delivery. Once verified, we will work to resolve the
                          issue quickly in line with our Returns, Refunds, Cancellation & Warranty Policy.
                        </span>
                      </span>
                    </span>
                  </li>
                </ol>
                <Link to="/returns-and-refund">Learn More</Link>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {!isLoading && (
        <>
          {!productData && (
            <div style={{ background: "#fff0", border: "none", padding: 0, margin: 0 }} className="alert alert-danger">
              {t("product_not_available")}
            </div>
          )}
        </>
      )}

      {isMobcreen && thisPricesList()}

      <h1 className="product-title" style={{ margin: "0px 3px", wordBreak: "auto-phrase", paddingTop: 0 }}>
        {isExpanded ? thisProTitle : truncatedTitle}
        {thisProTitle?.split(" ").length > 100 && (
          <span className="text-hover-link" onClick={toggleExpanded} style={{ fontSize: "0.9rem", cursor: "pointer" }}>
            {isExpanded ? " Show Less" : " See More"}
          </span>
        )}
      </h1>

      {isLoading ? (
        <div style={{ width: "100%" }}>
          <Skeleton variant="rect" style={{ height: "15px", width: "20%", margin: "0px 3px" }} />
          <Skeleton
            count={3}
            inline={true}
            variant="rect"
            style={{ height: "15px", width: "25%", margin: "0px 3px" }}
          />
          <Divider style={{ display: "flex", alignItems: "center", width: "92%", margin: "10px 3px" }} />
          <Skeleton variant="rect" style={{ height: "15px", width: "20%", margin: "0px 3px" }} />
          <Skeleton
            count={3}
            inline={true}
            variant="rect"
            style={{ height: "35px", width: "25%", margin: "0px 3px", marginBottom: "10px" }}
          />
          <Skeleton
            count={3}
            inline={true}
            variant="rect"
            style={{ height: "35px", width: "25%", margin: "0px 3px", marginBottom: "10px" }}
          />
          <Skeleton variant="rect" height={"15px"} width={"77%"} style={{ margin: "0px 3px" }} />
          <Skeleton variant="rect" height={"15px"} width={"66%"} style={{ margin: "0px 3px" }} />
          <Skeleton variant="rect" height={"15px"} width={"55%"} style={{ margin: "0px 3px" }} />
          <Skeleton variant="rect" height={"15px"} width={"44%"} style={{ margin: "0px 3px" }} />
          <Skeleton variant="rect" height={"15px"} width={"33%"} style={{ margin: "0px 3px" }} />
        </div>
      ) : (
        <>
          {productData?.brand && (
            <div className="pp--header-card">
              <span className="pp--header-title">{t("Brand")}:</span>
              <Link
                className="text-hover-link pp--header-hvr-link"
                style={{ fontWeight: 400, textTransform: "capitalize" }}
                to={`/search/${productData?.brand?.toLowerCase()}`}
              >
                {productData?.brand?.toLowerCase()}
              </Link>
            </div>
          )}

          <>
            <div
              className="pp--header-card"
              style={{
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap",
                gap: "10px",
                flexWrap: "nowrap",
                borderBottom: "1px solid #eee",
                paddingBottom: "10px",
                marginBottom: "10px",
              }}
            >
              <span className="pp--header-text">Sourced and fulfilled by {Host?.domainName}</span>
              <div className="il-summary-title-wrap">
                <span className="il-summary-title">
                  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="9" cy="9" r="8" fill="none" stroke="#6366f1" stroke-width="1.5" />
                    <circle cx="9" cy="5.5" r="1.2" fill="#6366f1" />
                    <rect x="7.9" y="8" width="2.2" height="5.5" rx="1" fill="#6366f1" />
                  </svg>
                </span>
                <div className="il-summary-tooltip">
                  {Host?.domainName} sources {productData?.brand} products from around the world from reputed suppliers
                  and delivers it to your doorstep.
                </div>
              </div>
            </div>
          </>

          <div
            className="pp--header-card"
            style={{ borderBottom: "1px solid #eee", paddingBottom: "10px", marginBottom: "10px" }}
          >
            {productData?.condition && (
              <>
                <span className="pp--header-title">{t("condition")}:</span>
                <span className="pp--header-text">{productData?.condition?.toLowerCase()} </span>
              </>
            )}
            {productData?.condition && productData?.rating && Number(productData?.rating) > 0 && (
              <Divider
                style={{ height: "17px", display: "flex", alignItems: "center", margin: "0px 5px" }}
                orientation="vertical"
              />
            )}
            {productData?.rating && Number(productData?.rating) > 0 ? (
              <>
                <span className="pp--header-text">{Number(productData?.rating) > 5 ? 5 : productData?.rating}</span>
                <Rating
                  style={{ color: "#fe7f4a", fontSize: "1rem", marginTop: "-1.5px" }}
                  name="read-only"
                  value={Number(productData?.rating) > 5 ? 5 : productData?.rating}
                  precision={0.1}
                  readOnly
                />
              </>
            ) : (
              ""
            )}
            {(productData?.rating && Number(productData?.rating) > 0) ||
              (productData?.condition && (
                <Divider
                  style={{ height: "17px", display: "flex", alignItems: "center", margin: "0px 5px" }}
                  orientation="vertical"
                />
              ))}
            <div
              className="text-hover-link pp--header-hvr-link"
              onClick={() => returnPolicyModal()}
              style={{ display: "flex", alignItems: "center", border: "none", cursor: "pointer" }}
            >
              <span className="value" style={{ textDecoration: "underline" }}>
                {Host?.domainName} {t("protect")}
              </span>
              <InfoOutlinedIcon style={{ fontSize: "1.1rem", margin: "0px 2px", color: "#8a8a8a" }} />
            </div>
          </div>

          {!isMobcreen && thisPricesList()}

          {productNotAvailable ? (
            <div className="pp--header-card">
              <span className="pp--header-title">{t("availability")}:</span>
              <span className="pp--header-text" style={{ color: "tomato" }}>
                {productData?.variants ? t("currently_not_available") : t("out_of_stock")}
              </span>
            </div>
          ) : (
            <>
              {getStockQnty(
                productData?.inventory && Number(productData?.qty) > 0 ? productData?.qty : productData?.quantity
              )}
            </>
          )}

          <Variation productData={productData} isLoading={isLoading} isFetching={isFetching} id={id} />

          <div
            className="pp--header-card"
            style={{ borderTop: "1px solid rgb(238, 238, 238)", paddingTop: "10px", marginTop: "10px" }}
          >
            <div className="pp--header-text">
              <div style={{ display: "flex", alignItems: "center", color: "#333638", gap: "5px" }}>
                <span className="pp--header-text">{t("imported_from")}</span>
                <img
                  style={{ width: "22px", objectFit: "contain" }}
                  loading="lazy"
                  src={`https://flagcdn.com/w20/${productData?.country?.toLowerCase()}.png`}
                  srcSet={`https://flagcdn.com/w40/${productData?.country?.toLowerCase()}.png 2x`}
                  alt=""
                />
                <span className="pp--header-text">{ProductCountries(productData?.country)}</span>
              </div>
            </div>
            {productData?.store_id != 3 && (
              <Divider
                style={{ height: "17px", display: "flex", alignItems: "center", margin: "0px 5px" }}
                orientation="vertical"
              />
            )}
            {productData?.store_id != 3 && localViewStore()}
          </div>

          {isMobcreen && (
            <>
              <div className="pp--header-card">
                <span className="pp--header-title">{t("estimated_delivery")}</span>
                <span className="pp--header-text">{getDeliverydays()}</span>
              </div>
              {/* {tabbyCurrencies?.includes(userData?.contant?.currency) &&
                <div className='pp--header-card'>
                  <span className='pp--header-text'>{t('split_payment')}</span>
                  {!productNotAvailable &&
                    <span className='pp--header-text'>
                      {productFetching ? <Skeleton variant="rect" style={{ height: '12px', width: '50px' }} /> :
                        <strong>
                          {formatPrice(Number(productData?.prices?.value) / 4, productData?.prices?.currency ? productData?.prices?.currency : userData?.contant?.currency, 0)}.</strong>
                      }
                    </span>
                  }
                  <span className='pp--header-text'>{t('no_interest')}</span>
                  <img src='/tabby-logo-1.png' style={{ width: '40px' }} />
                </div>
              } */}
            </>
          )}

          <div className="pp--header-card">
            {thisFeatures?.length > 0 && (
              <div className="pp--header-title" style={{ marginTop: "5px" }}>
                {t("product_features")}:
              </div>
            )}
            <ul className="Page-card-header" style={{ padding: "0px 12px 0px 12px", width: "100%" }}>
              {thisFeatures?.length > 0 && (
                <>
                  {thisFeatures?.slice(0, getFeaturesLength ? 100 : 2)?.map((item, i) => (
                    <li style={{ color: "#38393a", fontSize: "13px", wordBreak: "auto-phrase" }} key={i}>
                      <div
                        style={{ wordBreak: "auto-phrase" }}
                        dangerouslySetInnerHTML={{ __html: item?.replace(/�/g, "'") }}
                      />
                    </li>
                  ))}
                  {thisFeatures?.length > 2 && (
                    <div
                      className="text-hover-link pp--header-hvr-link"
                      onClick={() => setFeaturesLength(getFeaturesLength ? false : true)}
                      style={{ cursor: "pointer" }}
                    >
                      {getFeaturesLength ? t("show_less") : t("show_more")}
                    </div>
                  )}
                </>
              )}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}

export default ProductFeatures;
